import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RegisterModalPage } from './register-modal';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    RegisterModalPage,
  ],
  imports: [
    TranslateModule,
    IonicPageModule.forChild(RegisterModalPage),
  ],
})
export class RegisterModalPageModule {}



// WEBPACK FOOTER //
// ./src/app/shared/register-modal/register-modal.module.ts